import {EMPLOYER, PARTNER, EMPLOYEE} from '@/constants/usersTypes'

const PaymentAccountPage = () => import(/* webpackChunkName: "payment-page" */ '@/views/payment/PaymentAccountPage')
const PaymentTransferPage = () => import(/* webpackChunkName: "payment-page" */ '@/views/payment/PaymentTransferPage')

export default [{
  path: 'payment-account',
  name: 'payment-account',
  component: PaymentAccountPage,
  meta: {
      requiresAuth: true,
      requiredUserTypes: [EMPLOYEE, PARTNER, EMPLOYER]
    }
}, {
  path: 'payment-transfer',
  name: 'payment-transfer',
  component: PaymentTransferPage,
  meta: {
      requiresAuth: true,
      requiredUserTypes: [EMPLOYEE, PARTNER, EMPLOYER]
    }
}]
